import $ from 'jquery'

// 首页
export const indexUtils = () => {
    // $(function(){ ... })
    // (function(){
    //     const init = () => {
    //         $('.req-txt-num').html($('.section-opt .req-pannel textarea').val().length);
    //     }
    //     init();
    // })();
    // 手风琴效果
    $('.section-star .mode-list .mode-item').hover(function() {
        $(this).addClass('mode-item-active').siblings().removeClass('mode-item-active');
    });

    $('.section-hot .tabs-list .tabs-item').click(function() {
        $(this).addClass('tabs-item-active').siblings().removeClass('tabs-item-active');
        $('.tabs-pannel-' + $(this).data('key')).show().siblings('.section-hot .tabs-content .tabs-pannel').hide();
    });
}

// 特征抽取
export const featureUtils = () => {
    // 方法定义
    const main = {
        txtAreaInitValue: '拍拍贷是一家金融科技公司，2007年成立于上海，并在2017年11月10日成功于美国纽交所上市。截至2019年6月30日，拍拍贷累计注册用户数达到9902万人。累计借款用户数为1340万人；累计投资用户数为64.44万人，实现持续增长拍拍贷是一家金融科技公司，2007年成立于上海，并在2017年11月10日成功于美国纽交所上市。截至2019年6月30日，拍拍贷累计注册用户数达到9902万人。累计借款用户数为1340万人；累计投资用户数为64.44万人，实现持续增长拍拍贷是一家金融科技公司，2007年成立于上海，并在2017年11月10日成功于美国纽交所上市。截至2019年6月30日，拍拍贷累计注册用户数达到9902万人。',
        init: function(){
            $('#txtFeature').val(this.txtAreaInitValue);
            $('.req-txt-num').html(this.txtAreaInitValue.length)
        }
    }
    $(function(){
        main.init();
    });
     //事件
    $('.section-opt .req-pannel').on('click', '.txt-demo', function(){
        let txtVal = '';
        if('ppdai' === $(this).data('key')){
            txtVal = main.txtAreaInitValue;
        }
        if('loan' === $(this).data('key')){
            txtVal = '您尾号8866的卡片，已经逾期超过30天，剩余应还5000元，请及时还款避免对个人信用产生影响';
        }
        $('#txtFeature').val(txtVal);
        $('.req-txt-num').html(txtVal.length)
        $(this).addClass('txt-demo-active').siblings().removeClass('txt-demo-active');
    });
    
    $('.section-opt .req-pannel textarea').on('input propertychange', function(){
        var _length = $(this).val().length;
         $('.req-txt-num').html(_length);
    });
}

// 语速检测
export const speakUtils = () => {
    //
    const main = {
        jsonInitValue: '{"content":{"face_num":1,"imgno":99,"list":[{"age":"21-30","gender":"女性","imageurl":"https://aifile.ppdai.com/a6f144757fbf4629bb7687cdf5beeca4.jpg","landmark_i":[{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156},{"x":77,"y":156}]}],"main_image":"https://aifile.ppdai.com/a6f144757fbf4629bb7687cdf5beeca4.jpg","multi_image":false,"serieNo":"CY83VQ040L0A5BLDZA"},"responseCode":0}',
        init: function(){
            // 语速：
            $('.speed-bar div').removeClass('speed-bar-warning').addClass('speed-bar-normal');
            // 每秒钟：
            $('.count-word').text(9);
            // 语音质量：
            $('#voiceQuality').text("正常");

            // 返回结果
            const jsonData = JSON.parse(this.jsonInitValue);
            $('#jsonContent').text(JSON.stringify(jsonData['content'], null, '\t'));
        }
    }
    $(function(){
        main.init();
    });
}
 
// 人脸识别
export const faceUtils = () => {
    // 
    $('.section-opt .tabs-list').on('click', '.tabs-item', function(){
        $(this).addClass('tabs-item-active').siblings().removeClass('tabs-item-active');
        $('.tabs-pannel-' + $(this).data('key')).show().siblings('.section-opt .tabs-content .tabs-pannel').hide();
    });

    $('.section-opt .thumb-list').on('click', '.thumb-item', function(e){
        $(this).addClass('thumb-item-active').siblings().removeClass('thumb-item-active');
    });
}

// 三方数据管理平台
export const threeUtils = () => {
    $('.section-hot .tabs-list .tabs-item').click(function() {
        console.log($(this)[0]);
        $(this).addClass('tabs-item-active').siblings().removeClass('tabs-item-active');
        $('.tabs-pannel-' + $(this).data('key')).show().siblings('.section-hot .tabs-content .tabs-pannel').hide();
    });
}